import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
import { agencies } from '../mockData';
import AnimatedSection from './AnimatedSection';

const AgencySection = () => {
  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-3">Nos services en Alpes-de-Haute-Provence</h2>
          <p className="text-gray-600">Prenez contact avec notre atelier de Villars-Colmars</p>
          <a href="/nos-agences" className="inline-block mt-4 text-[#c4d600] hover:text-[#b0c200] font-semibold text-sm transition-colors">
            Toutes nos agences
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {agencies.map((agency, index) => (
            <AnimatedSection 
              key={agency.id} 
              animation="fade-up" 
              delay={index * 100}
            >
              <div className="bg-white rounded-lg p-6 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group h-full">
                <h3 className="font-bold text-lg text-gray-800 mb-4 group-hover:text-[#c4d600] transition-colors">{agency.name}</h3>
                
                <div className="space-y-3 mb-4">
                  <p className="text-gray-600 text-sm">
                    {agency.address}<br />
                    {agency.postalCode} {agency.city}
                  </p>
                </div>

                <div className="flex flex-col space-y-3">
                  <a
                    href={agency.mapUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center text-gray-600 hover:text-[#c4d600] transition-all duration-200 group/link"
                  >
                    <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center mr-2 group-hover/link:bg-[#c4d600] transition-colors">
                      <MapPin className="w-4 h-4 group-hover/link:text-white transition-colors" />
                    </div>
                  </a>
                  
                  <a
                    href={`tel:${agency.phone}`}
                    className="flex items-center text-gray-600 hover:text-[#c4d600] transition-all duration-200 group/link"
                  >
                    <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center mr-2 group-hover/link:bg-[#c4d600] transition-colors">
                      <Phone className="w-4 h-4 group-hover/link:text-white transition-colors" />
                    </div>
                  </a>
                  
                  <a
                    href={`mailto:${agency.email}`}
                    className="flex items-center text-gray-600 hover:text-[#c4d600] transition-all duration-200 group/link"
                  >
                    <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center mr-2 group-hover/link:bg-[#c4d600] transition-colors">
                      <Mail className="w-4 h-4 group-hover/link:text-white transition-colors" />
                    </div>
                  </a>
                </div>

                <a
                  href={`/agence/${agency.id}`}
                  className="block mt-4 text-sm font-semibold text-gray-800 hover:text-[#c4d600] transition-colors"
                >
                  voir l'agence
                </a>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AgencySection;